import { circlePrompts } from './circles.ts';

/** English volume prompts (ADR 0095 §3, §5). */
export const volumePrompts = {
    countCubes: () => `How many unit cubes fill this box?`,
    edgeLengths: () => `What is the volume?`,
    twoBoxes: () => `What is the volume of this solid?`,
    surfaceAreaNet: () => `This net folds into a box. What is its surface area?`,
    surfaceAreaBox: () => `What is the surface area of this box?`,
    missingEdge: (volume: string) => `The volume is ${volume}. What is the missing edge?`,
    /** ADR 0140 §4: the solid is named, and the pi sentence is Circles'. */
    cylinder: () => `What is the volume of the cylinder? ${circlePrompts.piSentence()}`,
    cone: () => `What is the volume of the cone? ${circlePrompts.piSentence()}`,
    sphere: () => `What is the volume of the sphere? ${circlePrompts.piSentence()}`,
    /** A number of hundredths as the sheet writes it: a point. */
    decimal: circlePrompts.decimal,
    /** The counting answer, e.g. "24 cubes". Never 1, so always the plural. */
    cubes: (count: number) => `${count} cubes`,
};
